import { useState } from 'react';

import {
  Button,
  Checkbox,
  Column,
  Row,
} from '../../../components';
import RecoveryCodesList from '../../../components/secondFactor/RecoveryCodesList';
import {
  useAuth,
  useTownAssets,
} from '../../../stores';
import { config } from '../../../utils';
import printRecoveryCodes from '../../../utils/secondFactor/printRecoveryCodes';

function LoginStepRecoveryCodes() {
  const { auth } = useAuth();
  const { assets } = useTownAssets();
  const { translate } = assets;
  const [codes, setCodes] = useState();
  const [handled, setHandled] = useState(false);
  const [saved, setSaved] = useState(false);
  const [pending, setPending] = useState(false);
  const [failed, setFailed] = useState(false);

  // Asked for on a click: each request replaces the batch, so none may go out unseen
  const issue = async () => {
    setPending(true);
    setFailed(false);

    const answer = await auth.server.loginStep(config.town.back.auth.loginStep.recoveryCodesIssue);

    setPending(false);
    if (answer.recoveryCodes) setCodes(answer.recoveryCodes);
    else if (!answer.loginPendingExpired) setFailed(true);
  };

  const confirmSaved = async () => {
    setPending(true);
    setFailed(false);

    const answer = await auth.server.loginStep(config.town.back.auth.loginStep.recoveryCodesSaved);

    // Once the session is open this form is gone, and must not touch its state
    if (answer.done) return;

    setPending(false);
    if (!answer.loginPendingExpired) setFailed(true);
  };

  return (
    <Column gap={4} className="max-w-120">
      <span className="font-semibold">{translate('recoveryCodes')}</span>

      {(codes)
        ? (
            <>
              <RecoveryCodesList codes={codes} onHandled={() => setHandled(true)} />

              <Checkbox
                id="recoveryCodesSaved"
                checked={saved}
                onChange={(event) => setSaved(event.currentTarget.value === true)}
                disabled={!handled}
                label={translate('recoveryCodesISavedThem', 'statements')}
              />
            </>
          )
        : <span>{translate('recoveryCodesIntro', 'statements')}</span>}

      {(failed)
        ? <span className="text-pxUiAlert">{translate('reqFailed', 'statements')}</span>
        : <span>{' '}</span>}

      <Row gap={6}>
        {(codes)
          ? (
              <Row gap={10}>
                <Button
                  label={translate('print')}
                  imgSrc="/images/svg/gui/print.svg"
                  onClick={() => {
                    if (printRecoveryCodes(`Paxity - ${translate('recoveryCodes')}`, codes)) setHandled(true);
                  }}
                  neutralColor
                />

                <Button
                  label={translate('continue')}
                  onClick={confirmSaved}
                  disabled={(!saved) || pending}
                  pending={pending}
                  baseColor
                />
              </Row>
            )
          : (
              <Button
                label={translate('recoveryCodesShow', 'statements')}
                onClick={issue}
                disabled={pending}
                pending={pending}
                baseColor
              />
            )}
      </Row>
    </Column>
  );
}

export default LoginStepRecoveryCodes;
